module.exports = __webpack_public_path__ + "img/boxes.877d9025.png";